import styled from "styled-components";

export const Header = styled.div`
    display:flex;
    justify-content:center;
    align-items: center;
    font-family: Lato-Bold;
    color: var(--main-teal-color);
    font-size: 2em;
    
`;
export const Content = styled.div`
    font-family: Lato-Bold;
    background-color: var(--main-teal-color);
    color: #fff;
    width: 100%;
    padding: 10px;
`;
export const InfoRow = styled.div`
    display:flex;
    justify-content: space-between;
`;
export const InfoHeader = styled.p`
    font-family: Lato-Light;
`;
export const InfoText = styled.p`
    text-align:right;
    font-family: Lato-Bold;
`;
export const InfoLine = styled.hr`
    margin: 0;
    text-align: left;
    background-color: #fff;
`;
export const Link = styled.a`
    display:block;
    padding:1vw;
`;
export const CheckBoxContainer = styled.div`
    display:block;
    padding:0.5vw;
`;